import React from 'react'
import Table from '../Table/Table'
import DetailView from '../../../dpe-usco/components/Details/DetailView'

export const DetailCardWithTable = ({
  title,
  button,
  structure,
  data,
  statusComponent,
  onScrollAPI,
  dataTestId,
  subRowStructure,
  dropdownCallback,
  deleteMultipleScaleTickets,
  totalSelectedRow,
  productionPlanId,
  isLoadExtraData
}) => {
  return (
    <DetailView button={button} title={title} disableBack={true}>
      <div className="mb20 mt20">
        {data && (
          <Table
            dataTestId={dataTestId}
            structure={structure}
            subRowStructure={subRowStructure}
            data={data}
            isLoadExtraData={isLoadExtraData}
            statusComponent={statusComponent}
            onScrollAPI={onScrollAPI}
            dropdownCallback={dropdownCallback}
            deleteMultipleScaleTickets={deleteMultipleScaleTickets}
          />
        )}
      </div>
    </DetailView>
  )
}

export default DetailCardWithTable
